export default "__VITE_ASSET__bJQy8rzE__"